// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n#Clients-page{\r\n    height: calc(100% - 1px);\r\n}\r\n#Clients-page .filter-wrapper + .table{\r\n    height: calc(100% - (20px + 122px)) !important;\r\n}", ""]);
// Exports
module.exports = exports;
